import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

export const fetchCampaignData = createAsyncThunk(
  "campaign/fetchCampaignData",
  async (
    data:
      | string
      | {
          campaignId: string;
          ownerId?: string;
          userId?: string;
          workspaceId?: string;
        },
    { rejectWithValue }
  ) => {
    try {
      const payload =
        typeof data === "string" ? { campaignId: data } : data;
      const response = await axios.post("/campaign/getCampaignData", {
        campaignId: payload.campaignId,
        ownerId: payload.ownerId,
        userId: payload.userId,
        workspaceId: payload.workspaceId,
      });

      return response.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);
